import { createSelector } from 'reselect';

const getAppEntHelper = (state) => state?.userinfo?.entitlements;
const getWebEntHelper = (state) => state?.entitlements?.entitlementCodes;
const getFieldVisionLiveEntitlements = (state) => state?.config?.fieldVisionLiveEntitlements;
const getUseAppEnt = (state) => state?.config?.enableWebEntitlement === false;
const hasEntitlements = (list, fieldVisionLiveEntitlements) => {
    let match = false;
    
    if (typeof list !== 'undefined' && (fieldVisionLiveEntitlements && fieldVisionLiveEntitlements?.length > 0)) {
        const entSet = Array.isArray(list) ? new Set(list) : list;
        match = fieldVisionLiveEntitlements.some((ent) => entSet.has(ent));
    }
    
    return match;
};

export const getEntitlements = createSelector(
    [ getAppEntHelper, getWebEntHelper, getFieldVisionLiveEntitlements, getUseAppEnt],
    ( appEntitlements,  webEntitlements, fieldVisionLiveEntitlements, useAppEnt) => {
        const entitlementsList = useAppEnt ? appEntitlements : webEntitlements;
        return hasEntitlements(entitlementsList, fieldVisionLiveEntitlements);
    }
);